import realtimeUpdatesListeners from '././listeners/realtimeUpdates';
import applicationsListeners from './listeners/applications';
import commentListeners from './listeners/comments';
import eventsListeners from './listeners/events';
import projectListListeners from './listeners/projectList';
import ratingListeners from './listeners/rating';
import relevanceProcessingListener from './listeners/relevanceProcessing';
import selectionLevelListeners from './listeners/selectionLevel';
import selectionLevelConfigListeners from './listeners/selectionLevelConfig';
import tagListeners from './listeners/tags';
import listenersStore, { ListenerList } from './listenersStore';

const listenersList: ListenerList = {
  commentListeners,
  tagListeners,
  ratingListeners,
  eventsListeners,
  realtimeUpdatesListeners,
  selectionLevelListeners,
  selectionLevelConfigListeners,
  projectListListeners,
  applicationsListeners,
  relevanceProcessingListener
};

export default listenersStore(listenersList);
